<template>
  <header class="header">
    <div class="logo">
      <img src="../assets/logo.png" alt="Logo" />
      <span class="bold-text">社会招聘</span>
    </div>
    <nav>
<!--      <a v-for="item in menuItems" :key="item.text" :href="item.link">{{ item.text }}</a>-->
    </nav>
  </header>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      menuItems: [
        { text: '新闻中心', link: '#' },
        { text: '投资者', link: '#' },
        { text: '加入我们', link: '#' },
        { text: '联系我们', link: '#' }
      ]
    }
  }
}
</script>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background: white;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.logo {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-left: 350px;
}

.logo img {
  height: 2rem;
}

nav {
  display: flex;
  gap: 2rem;
}

nav a {
  color: #333;
  text-decoration: none;
}

nav a:hover {
  color: #1890ff;
}
.bold-text{
  font-weight: bold;
  display: inline-block;
}
</style>
